import { User } from 'models'
import { message } from 'antd'
import { uploadImage } from 'helpers'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useTranslations } from 'contexts/Translation'
import { useUser } from 'domains/User/context'
import { updateDocument } from '../../../../../../../services/api/firebase'
import { COLLECTIONS } from '../../../../../../../__constants__'

const useActionsUserAdvancedForm = ({
  initialData,
  form,
  changeUserPhone
} = {}) => {
  /* State for loading */
  const [loading, setLoading] = useState(false)
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()

  const {
    user: { _id }
  } = useUser()
  /* Function for preparing values for saving */
  const prepareValues = async (values = {}, additionalValues = {}) => {
    /* Preparing user values */
    return {
      _id: _id,
      ...additionalValues,
      firstName: values?.['user']?.['firstName'] ?? null,
      lastName: values?.['user']?.['lastName'] ?? null,
      email: values?.['user']?.['email'] ?? null,
      phoneNumber: values?.['user']?.['phoneNumber'] ?? null,
      avatarUrl: (await uploadImage(values?.['user']?.['avatarUrl'])) ?? null
    }
  }
  /* Saving form data */
  const saveForm = async (values, callback) => {
    try {
      // Prepare data to be saved
      const data = await prepareValues(values)

      // Check is user phone need to update

      const isPhoneChanged =
        data?.phoneNumber !== initialData?.user?.phoneNumber

      // Save data
      if (isPhoneChanged) {
        await changeUserPhone(data?.phoneNumber, {
          _id: initialData.user?._id,
          data
        })
      } else {
        await updateDocument(COLLECTIONS.USERS, initialData.user?._id, data)

        message.success(t('Profile successfully updated'))

        callback?.()
      }
    } catch (error) {
      message.error(t('Something went wrong during data save'))
    }
  }

  /* Function for validating form */
  const validateForm = (values) => {
    try {
      // Prepare data to be validated
      const validationData = {
        firstName: values?.['user']?.['firstName'],
        lastName: values?.['user']?.['lastName'],
        email: values?.['user']?.['email'],
        phone: values?.['user']?.['phone'],
        avatarUrl: values?.['user']?.['avatarUrl']
      }
      User.validationSchema.validateSync(validationData)
    } catch (error) {
      message.error(t('User validation error: ') + t(error.message))
    }
  }

  /* On finish callback */
  const onFinish = async () => {
    if (loading) return // Avoid multiple calls

    try {
      setLoading(true)
      // Get form values
      const formValues = form.getFieldsValue()
      // Validate fields
      validateForm(formValues)

      // Final callback
      const callback = () => history.goBack()
      // Save data
      await saveForm(formValues, callback)
    } catch (error) {
      message.error(error.message)
    } finally {
      setLoading(false)
    }
  }

  /* On cancel callback */
  const onReset = () => {
    form.resetFields()
    history.goBack()
  }

  return { onFinish, onReset, loading, saveForm, validateForm, prepareValues }
}

export default useActionsUserAdvancedForm
